import { render, staticRenderFns } from "./SavingsEditorNavbar.vue?vue&type=template&id=de61c864&"
import script from "./SavingsEditorNavbar.vue?vue&type=script&lang=js&"
export * from "./SavingsEditorNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SavingsEditorNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports